// src/common/SEO.jsx
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const pageSEO = {
  // Main Pages
  "/": {
    title:
      "Incubation Masters | Economic Development Advisory | Global Startup Incubation | IM Global",
    description:
      "Incubation Masters is a global advisory platform enabling startups governments and enterprises through innovation incubation economic development and foreign investment strategies.",
  },
  "/About": {
    title:
      "About Incubation Masters | Vision Leadership and Impact | IM Global",
    description:
      "Learn about Incubation Masters our mission leadership and approach to building startup ecosystems enabling economic growth and strengthening global innovation networks.",
  },
  "/our-offerings": {
    title:
      "Our Offerings | Startup Advisory Economic Development and FDI Services | IM Global",
    description:
      "Explore our services including startup incubation economic advisory investment facilitation innovation programs and ecosystem development for governments and enterprises.",
  },
  "/leadership": {
    title:
      "Leadership | Experts in Innovation and Economic Strategy | IM Global",
    description:
      "Meet the leadership team driving Incubation Masters with deep expertise in startup ecosystems economic policy and global development.",
  },
  "/platform": {
    title: "EIM Login | Access Platform and Tools | IM Global | Elevate by IM",
    description:
      "Secure access to the Incubation Masters platform (EIM) for founders partners and ecosystem stakeholders to manage growth and insights.",
  },
  "/clients": {
    title: "Clients and Impact | Success Stories and Partnerships | IM Global",
    description:
      "Discover how Incubation Masters partners with governments startups and enterprises to deliver measurable economic and innovation outcomes worldwide.",
  },
  "/contact-us": {
    title: "Contact Us | Connect with Incubation Masters | IM Global",
    description:
      "Get in touch with Incubation Masters to discuss startup incubation economic advisory FDI strategies or platform access. Our team is ready to accelerate your growth.",
  },
  "/insights-resources": {
    title: "Insights | Economic Development & Startup Trends | IM Global",
    description:
      "Explore latest insights reports and thought leadership on startup ecosystems economic development FDI and global innovation from Incubation Masters.",
  },
  "/insights-resources": {
    title: "Resources | Tools Guides & Downloads | IM Global",
    description:
      "Access free resources guides templates and tools for startups governments and enterprises from Incubation Masters.",
  },
  "/career": {
    title: "Careers | Join Incubation Masters Team | IM Global",
    description:
      "Explore career opportunities at Incubation Masters and join our mission to drive global startup ecosystems and economic development.",
  },
  "/elevate-by-im": {
    title: "Elevate by IM | AI Powered Startup and Growth Platform | IM Global",
    description:
      "Elevate by IM is an intelligent platform designed to help founders validate ideas plan growth and build scalable ventures using data driven insights.",
  },

  // Platforms
  "/trade-intelligence-platform": {
    title: "Trade Intelligence Platform | Export & Market Insights | IM Global",
    description:
      "Access real-time trade intelligence market data and export promotion tools powered by Incubation Masters for governments and enterprises.",
  },
  "/fdi-intelligence-plateform": {
    title:
      "FDI Intelligence Platform | Investment Attraction Tools | IM Global",
    description:
      "Leverage FDI intelligence data analytics and investment promotion platform by Incubation Masters to attract global investments.",
  },

  // Tools
  "/startup-idea-validator-tools": {
    title:
      "Startup Idea Validator Tool | Validate Your Business Idea | Elevate by IM",
    description:
      "Validate your startup idea with data-driven insights market potential and feasibility analysis using Elevate by IM.",
  },
  "/business-model-generator": {
    title: "Business Model Generator | Canvas & Planning Tool | Elevate by IM",
    description:
      "Build and refine your business model using AI-powered canvas templates and strategic guidance from Elevate by IM.",
  },

  // Value Proposition Pages
  "/startup-consulting": {
    title: "Startup Innovation and Incubation | Incubation Masters | IM Global",
    description:
      "We support startups through structured incubation innovation frameworks mentorship and strategic guidance to accelerate sustainable business growth.",
  },
  "/startup-investment": {
    title: "Investment Promotion | FDI and Capital Attraction | IM Global",
    description:
      "Expert investment promotion strategies and FDI facilitation services to attract global capital and drive economic growth.",
  },
  "/startup-advisory": {
    title: "Strategic Advisory to Governments | Economic Policy | IM Global",
    description:
      "Tailored economic development and policy advisory for governments to build thriving innovation ecosystems.",
  },
  "/startup-market-entry": {
    title:
      "International Market Entry Assistance | Global Expansion | IM Global",
    description:
      "Support for startups and enterprises entering new international markets with strategy research and partnerships.",
  },
  "/startup-future-of-startup": {
    title: "The Future of Startups is Here | Elevate by IM | IM Global",
    description:
      "Discover the next generation of startup tools powered by AI data and global insights from Incubation Masters.",
  },
  "/startup-curated-sector": {
    title:
      "Curated Sector-Specific Cohorts | Industry Acceleration | IM Global",
    description:
      "Join specialized startup cohorts focused on high-growth sectors with mentorship funding access and market connections.",
  },

  // Media & Events
  "/blog": {
    title: "Blog | Startup Innovation & Economic Insights | IM Global",
    description:
      "Read the latest blog posts on startup trends economic development FDI strategies and innovation from Incubation Masters experts.",
  },
  "/podcast": {
    title: "Podcast | Conversations on Innovation & Growth | IM Global",
    description:
      "Listen to in-depth discussions with global leaders on startup ecosystems economic policy and innovation.",
  },
  "/webinar": {
    title: "Webinars | Live Sessions on Economic Development | IM Global",
    description:
      "Join our live and on-demand webinars on FDI trade promotion startup growth and innovation strategies.",
  },

  // Legal & Others
  "/thank-you": {
    title: "Thank You | Incubation Masters",
    description:
      "Thank you for contacting Incubation Masters. Our team will reach out shortly.",
  },
  "/term-of-use": {
    title: "Terms of Use | Incubation Masters | IM Global",
    description:
      "Read the terms and conditions for using Incubation Masters platforms and services.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Incubation Masters | IM Global",
    description:
      "Learn how Incubation Masters protects your data and privacy across our platforms and services.",
  },
  "/fdi-institute": {
    title: "FDI Institute | Investment Promotion & FDI Strategy | IM Global",
    description:
      "Empowering governments and organizations with expert FDI strategies, investment promotion tools, and economic facilitation services to attract global capital.",
  },
};

const defaultSEO = {
  title:
    "Incubation Masters | Global Economic Development & Startup Advisory | IM Global",
  description:
    "Leading global platform for startup incubation economic development FDI intelligence trade promotion and innovation ecosystem building.",
};

const globalKeywords =
  "startup incubation, economic development, Trade and Export Promotion, innovation ecosystem, business consulting, investment promotion, Elevate by IM, Incubation Masters, IM Global";

export default function SEO() {
  const location = useLocation();
  const currentPath = location.pathname;

  const seo = pageSEO[currentPath] || defaultSEO;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={globalKeywords} />

      {/* Optional: Open Graph for better social sharing */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={`https://www.incubationmasters.com${currentPath}`}
      />
      <meta property="og:site_name" content="Incubation Masters Global" />
    </Helmet>
  );
}
